/**
 * [sc-48538 / task 48539] Quanto imballo si addebita su un preventivo.
 *
 * La regola è la stessa del server, che nel totale mette
 * `CASE WHEN "hasPackagingFee" THEN COALESCE("packagingFeeAmount", 0) ELSE 0`:
 * la casella decide *se*, il preventivo dice *quanto*. L'importo è
 * storicizzato sulla riga proprio perché un domani può cambiare senza
 * riscrivere i documenti già emessi.
 *
 * Sta in un file suo e non dentro il generatore del PDF perché lì non si può
 * entrare da un test: quel modulo carica jspdf e usa `import.meta`.
 */
export function packagingFeeOf(quote) {
  if (!quote?.hasPackagingFee) return 0;
  const amount = Number(quote.packagingFeeAmount);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
}

export default packagingFeeOf;
